<template>
  <van-popup
    v-model="showTimePopup"
    round
    position="bottom"
    :style="{ height: '50%' }"
  >
    <van-datetime-picker
      :value="currentDate"
      :type="type"
      :title="typeTime"
      :min-date="minDate"
      :max-date="maxDate"
      @cancel="showTimePopup = false"
      @confirm="handleTimeConfirm"
      :formatter="formatter"
      :filter="filter"
    />
  </van-popup>
</template>

<script>
import moment from 'moment'

export default {
  // props: ['currentDate', 'maxDate', 'minDate'],
  props: {
    currentDate: {
      default: () => {
        return ''
      },
    },
    type: {
      default: () => {
        return 'datetime'
      },
    },
    maxDate: {},
    minDate: {},
    isFilter: {
      default: () => {
        return true
      },
    },
    typeTime:{}
  },

  watch: {
    currentDate() {},
  },
  data() {
    return {
      showTimePopup: false,
      // minDate: new Date(),
      // curDate: this.currentDate && this.currentDate,
      // maxDate: this.maxDate && this.maxDate,
      // selectTime: null,
    }
  },
  methods: {
    filter(type, options) {
      if (!this.isFilter) {
        return options
      }
      if (type === 'minute') {
        return options.filter((option) => option % 10 === 0)
      }
      //  获取当前分钟，添加进数组,判断为一位添加进第一项
      // const m = moment().format('m')
      // if (m.length === 1 && type === 'minute') {
      //   return [m, 10, 20, 30, 40, 50]
      // }
      // if (m.length > 1 && type === 'minute') {
      //   let res = []
      //   const start = Number(m[0] + `0`) + 10
      //   for (let i = start; i <= 50; i += 10) {
      //     res.push(i)
      //   }
      //   return [m, ...res]
      // }
      return options
    },
    handleTimeConfirm(value) {
      console.log('默认值value',value)
      if (this.type == 'date') {
        // console.log('走着')
        this.$emit('time', moment(value).format('YYYY-MM-DD'))
      } else if (this.type == 'time') {
        // console.log('走着1')
        if (!value) {
          this.$emit('time', '00:00')

        } else {
          this.$emit('time', moment(value,'HH:mm').format('HH:mm'))

        }
      }else {
          this.$emit('time', moment(value).format('YYYY-MM-DD HH:mm'))
      } 
      this.showTimePopup = false
    },
    formatter(type, val) {
      if (type === 'year') {
        return val + '年'
      }
      if (type === 'month') {
        return val + '月'
      }
      if (type === 'day') {
        return val + '日'
      }
      if (type === 'hour') {
        return val + '时'
      }
      if (type === 'minute') {
        return val + '分'
      }
      return val
    },
  },
}
</script>

<style lang="scss" scoped></style>
